import cx from 'classnames';
import React from 'react';
import styles from './PostMenuTrigger.mscss';

interface OwnProps {
    className?: string;
    onClick: React.MouseEventHandler<HTMLElement>;
}

type Props = OwnProps;

class PostMenuTrigger extends React.Component<Props> {

    public render() {
        const { className, onClick } = this.props;

        return (
            <i
                className={cx('fa fa-chevron-down', styles.PostMenuTrigger, className)}
                onClick={onClick}
                role="button"
                tabIndex={0}
            />
        );
    }

}

export default PostMenuTrigger;
